"use strict";
// Placeholders - Once the page has loaded we should remove the placeholders.
(function ($) {
    $(window).on('load', function () {
        if ($('.placeholder').length) {
            $('.placeholder').removeClass('placeholder');
        }
    });
})(jQuery);
